import { Link } from 'react-router';
import { Trophy } from 'lucide-react';

export default function RegulaminPage() {
  return (
    <main className="min-h-screen bg-white text-neutral-900">
      <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(1400px_800px_at_50%_0%,rgba(0,102,255,0.06),transparent_70%)]" />
      </div>

      <header className="sticky top-0 z-50 border-b border-neutral-200/60 bg-white/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="relative h-11 w-11 rounded-2xl bg-gradient-to-br from-[#0066FF] to-[#00C7B1] text-white grid place-items-center font-bold text-base shadow-lg">
              <Trophy className="w-6 h-6" />
            </div>
            <span className="text-xl font-extrabold tracking-tight bg-gradient-to-r from-[#0066FF] to-[#00C7B1] bg-clip-text text-transparent">
              Turnivo
            </span>
          </Link>
          <Link
            to="/"
            className="text-sm font-medium text-neutral-600 hover:text-neutral-900 transition"
          >
            ← Strona główna
          </Link>
        </div>
      </header>

      <article className="mx-auto max-w-4xl px-6 py-12 md:py-16">
        <h1 className="text-4xl font-extrabold tracking-tight text-neutral-900 mb-2">
          Regulamin
        </h1>
        <p className="text-neutral-500 text-sm mb-10">
          Regulamin świadczenia usług w serwisie Turnivo — system organizacji turniejów siatkarskich. Ostatnia aktualizacja: {new Date().toLocaleDateString('pl-PL', { day: 'numeric', month: 'long', year: 'numeric' })}
        </p>

        <div className="prose prose-neutral max-w-none space-y-8 text-neutral-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-neutral-900 mt-8 mb-3">§ 1. Postanowienia ogólne</h2>
            <ol className="list-decimal pl-6 space-y-2">
              <li>Regulamin określa zasady korzystania z serwisu Turnivo („Serwis”) — platformy internetowej umożliwiającej organizację turniejów siatkarskich, prowadzenie wyników na żywo, udostępnianie publicznych linków do wyników, panel sędziego oraz powiązane funkcje („Usługa”).</li>
              <li>Usługę świadczy operator Serwisu („Usługodawca”). Kontakt: dane podane na stronie turnivo.pl.</li>
              <li>Korzystanie z Serwisu w sposób wymagający rejestracji (konto, plany płatne) oznacza akceptację niniejszego Regulaminu oraz Polityki prywatności.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mt-8 mb-3">§ 2. Definicje</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Użytkownik</strong> — osoba fizyczna, prawna lub jednostka organizacyjna korzystająca z Serwisu.</li>
              <li><strong>Konto</strong> — indywidualny dostęp do panelu po rejestracji (e-mail, hasło, dane konta).</li>
              <li><strong>Plan / Subskrypcja</strong> — wybrana oferta (Trial, Basic, Optimum, Premium) określająca zakres funkcji i limitów (np. liczba aktywnych turniejów, drużyn; tryb ligi — od planu Optimum wzwyż, niedostępny w Basic; szczegóły w cenniku).</li>
              <li><strong>Turniej</strong> — event utworzony w Serwisie (drużyny, mecze, grupy, drabinka, wyniki).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mt-8 mb-3">§ 3. Rejestracja i konto</h2>
            <ol className="list-decimal pl-6 space-y-2">
              <li>Do pełnego korzystania z Usługi wymagana jest rejestracja: podanie imienia, nazwiska, numeru telefonu, adresu e-mail oraz hasła. Dane opcjonalne (adres, kod pocztowy, miejscowość) można uzupełnić w profilu.</li>
              <li>Aktywacja konta wymaga potwierdzenia adresu e-mail (kliknięcie w link w wiadomości wysłanej na podany adres). Do czasu potwierdzenia logowanie może być niedostępne.</li>
              <li>Numer telefonu i adres e-mail muszą być unikalne w systemie. Nie można założyć konta z numerem telefonu lub adresem e-mail już przypisanym do innego użytkownika.</li>
              <li>Użytkownik zobowiązuje się do podawania prawdziwych danych i utrzymywania bezpiecznego hasła. Usługodawca nie ponosi odpowiedzialności za skutki udostępnienia danych logowania osobom trzecim.</li>
              <li>Po rejestracji nowemu użytkownikowi przysługuje okres próbny (Trial) na warunkach opisanych w cenniku. Po jego zakończeniu konieczne jest wykupienie planu płatnego w celu dalszego korzystania z usług w pełnym zakresie.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mt-8 mb-3">§ 4. Plany i płatności</h2>
            <ol className="list-decimal pl-6 space-y-2">
              <li>Oferta obejmuje plany: Trial (okres próbny), Basic, Optimum, Premium. Szczegóły (limity, ceny, rabaty roczne, dostępność trybu ligi) są podane na stronie Serwisu (cennik).</li>
              <li>Płatności za plany płatne realizowane są przez zewnętrznego operatora płatności (np. TPay). Regulaminy i polityka prywatności operatora obowiązują w zakresie transakcji.</li>
              <li>Opłata jest pobierana z góry za wybrany okres (miesięczny lub roczny). Odnowienie subskrypcji następuje zgodnie z wybraną opcją, chyba że użytkownik wcześniej zrezygnuje.</li>
              <li>Zwroty i reklamacje dotyczące płatności rozpatrywane są zgodnie z przepisami prawa i zasadami operatora płatności. W sprawach usługi (działanie Serwisu) reklamacje należy składać u Usługodawcy.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mt-8 mb-3">§ 5. Zasady użytkowania Serwisu</h2>
            <ol className="list-decimal pl-6 space-y-2">
              <li>Użytkownik korzysta z Serwisu w sposób zgodny z prawem, Regulaminem i zasadami współżycia społecznego. Nie wolno m.in.: udostępniać treści bezprawnych, naruszających prawa third parties, wprowadzających w błąd; przeciążać infrastruktury; obchodzić zabezpieczeń ani ingerować w działanie Serwisu.</li>
              <li>Użytkownik jest odpowiedzialny za treści dodawane w ramach turniejów (nazwy drużyn, wyniki itp.). Publiczny link do wyników udostępnia dane w zakresie wybranym przez organizatora.</li>
              <li>Usługodawca dokłada starań, aby Serwis działał w sposób ciągły i niezawodny, nie gwarantuje jednak braku przerw (w tym z przyczyn technicznych lub konserwacyjnych). Wyniki na żywo (SSE) zależą od stabilności połączenia i działania urządzeń użytkownika.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mt-8 mb-3">§ 6. Własność intelektualna i licencja</h2>
            <p>
              Serwis, jego kod, interfejs, znaki towarowe i treści stanowiące własność Usługodawcy są chronione prawem. Użytkownik otrzymuje ograniczoną, niewyłączną licencję na korzystanie z Serwisu w ramach Usługi, bez prawa do kopiowania, modyfikacji ani odsprzedaży rozwiązania. Treści dodane przez użytkownika pozostają jego własnością; użytkownik udziela Usługodawcy licencji niezbędnej do świadczenia Usługi (przechowywanie, wyświetlanie, udostępnianie wyników itp.).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mt-8 mb-3">§ 7. Odpowiedzialność i wyłączenia</h2>
            <ol className="list-decimal pl-6 space-y-2">
              <li>Usługodawca ponosi odpowiedzialność za szkody wyrządzone użytkownikom wyłącznie w granicach przewidzianych prawem. Odpowiedzialność za utracone korzyści lub dane może być ograniczona do kwoty opłat zapłaconych w ostatnim okresie rozliczeniowym, o ile Regulamin lub przepisy nie stanowią inaczej.</li>
              <li>Usługodawca nie ponosi odpowiedzialności za działania użytkowników, treści przez nich dodane, awarie po stronie operatorów płatności, sieci lub urządzeń użytkownika oraz za siłę wyższą.</li>
              <li>W razie naruszenia Regulaminu Usługodawca może zawiesić lub usunąć konto oraz ograniczyć dostęp do Usługi, z zachowaniem przepisów prawa.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mt-8 mb-3">§ 8. Rozwiązanie umowy i rezygnacja</h2>
            <p>
              Użytkownik może w każdej chwili zrezygnować z płatnej subskrypcji (np. w ustawieniach konta). Dostęp do funkcji płatnych pozostaje do końca opłaconego okresu. Usługodawca może rozwiązać umowę z użytkownikiem w przypadkach określonych w Regulaminie lub przepisach prawa (m.in. naruszenie Regulaminu, zaległości w płatnościach). Dane osobowe są przetwarzane zgodnie z Polityką prywatności także po zakończeniu umowy (np. w celach rozliczeniowych i archiwalnych).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mt-8 mb-3">§ 9. Zmiany Regulaminu</h2>
            <p>
              Usługodawca może zmieniać Regulamin z ważnych przyczyn (m.in. zmiana prawa, zmiana funkcji Serwisu). O istotnych zmianach użytkownicy zostaną poinformowani z odpowiednim wyprzedzeniem (np. e-mail, komunikat w panelu). Kontynuowanie korzystania z Serwisu po wejściu w życie zmian oznacza ich akceptację. W razie braku akceptacji użytkownik może zrezygnować z Usługi przed wejściem w życie nowego Regulaminu.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mt-8 mb-3">§ 10. Postanowienia końcowe</h2>
            <ol className="list-decimal pl-6 space-y-2">
              <li>W sprawach nieuregulowanych Regulaminem zastosowanie mają przepisy prawa polskiego.</li>
              <li>Spory mogą być rozpatrywane przez sąd właściwy dla siedziby Usługodawcy lub dla miejsca zamieszkania / siedziby użytkownika, zgodnie z przepisami.</li>
              <li>W sprawach dotyczących danych osobowych stosuje się Politykę prywatności oraz RODO.</li>
            </ol>
          </section>
        </div>
      </article>

      <footer className="border-t border-neutral-200 bg-white mt-16">
        <div className="mx-auto flex max-w-4xl flex-col gap-4 px-6 py-8 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-2xl bg-gradient-to-br from-[#0066FF] to-[#00C7B1] text-white grid place-items-center font-bold text-sm shadow-lg">
              TU
            </div>
            <div>
              <div className="text-base font-extrabold">Turnivo</div>
              <div className="text-xs text-neutral-500">Organizacja turniejów siatkarskich</div>
            </div>
          </div>
          <div className="flex flex-wrap gap-4 text-sm text-neutral-500">
            <Link to="/" className="hover:text-neutral-900 transition">Strona główna</Link>
            <Link to="/polityka-prywatnosci" className="hover:text-neutral-900 transition">Polityka prywatności</Link>
            <Link to="/usuniecie-konta" className="hover:text-neutral-900 transition">Usunięcie konta</Link>
            <Link to="/wsparcie" className="hover:text-neutral-900 transition">Wsparcie</Link>
            <span>© {new Date().getFullYear()} Turnivo</span>
          </div>
        </div>
      </footer>
    </main>
  );
}
